export default __webpack_public_path__ + "assets/e739d5b28649876cb1faea414f952827.png";